module.exports = __webpack_public_path__ + "img/동암 맛집.9b14b563.png";